<div class="container main-container">

  <!-- Start: Header -->
  <div class="view-head mb-6">
    <div class="flex gap-4 items-center">
      <div alternativeBackRoute="/trial" backBtn [margin]="false" class="back-btn"></div>
      <h2 class="heading-small">Add New Trial</h2>
    </div>
  </div>
  <!-- End: Header -->

  <form [formGroup]="defaultForm">
    <div class="flex gap-4 mb-3">
      <div class="basis-2/3">
        <app-panel class="h-full" classNames="h-full">
          <div class="flex items-center justify-content-between">
            <h3>Basic Information</h3>

            @if (getBrandLogoUrl() != null) {
              <img src="{{ getBrandLogoUrl() }}" style="max-height: 30px; margin-bottom: 1.5rem;">
            }
          </div>

          <div class="flex gap-4">
            <!-- Start: Oracle Code -->
            <div class="basis-1/2">
              <div class="control-group">
                <label class="required" for="trial-internal-code">Oracle Code @if (isRequired('internalCode')) { <sup>*</sup> }</label>
                <input type="text" id="trial-internal-code" class="w-100" formControlName="internalCode">
              </div>
            </div>
            <!-- End: Oracle Code -->

            <!-- Start: Brand -->
            <div class="basis-1/2">
              <div class="control-group">
                <label class="required">Brand @if (isRequired('brandId')) { <sup>*</sup> }</label>
                <app-dropdown-input [options]="brandOptions" placeholder="Select..." (selectValueChanged)="onBrandChanged($event)"
                                    [parentForm]="defaultForm"
                                    #brandSelect controlName="brandId"></app-dropdown-input>
              </div>
            </div>
            <!-- End: Brand -->
          </div>

          <div class="flex gap-4">
            <!-- Start: Protocol Number -->
            <div class="basis-1/2 ">
              <div class="control-group">
                <label class="required" for="protocol-number">Protocol Number @if (isRequired('protocolNumber')) { <sup>*</sup> }</label>
                <input type="text" id="protocol-number" class="w-100" formControlName="protocolNumber">
              </div>
            </div>
            <!-- End: Protocol Number -->

            <!-- Start: Public Trial Code -->
            <div class="basis-1/2">
              <div class="control-group">
                <label class="required" for="trial-code">Public Trial Code @if (isRequired('code')) { <sup>*</sup> }</label>
                <input type="text" id="trial-code" class="w-100" formControlName="code">
              </div>
            </div>
            <!-- End: Public Trial Code -->
          </div>

          <div class="flex gap-4">
            <!-- Start: Client -->
            <div class="basis-1/2">
              <div class="control-group">
                <label class="required" for="client">Client @if (isRequired('client')) { <sup>*</sup> }</label>
                <input type="text" id="client" class="w-100" formControlName="client">
              </div>
            </div>
            <!-- End: Client -->

            <!-- Start: Sponsor -->
            <div class="basis-1/2">
              <div class="control-group">
                <label for="sponsor">Sponsor</label>
                <input type="text" id="sponsor" class="w-100" formControlName="sponsor">
              </div>
            </div>
            <!-- End: Sponsor -->
          </div>

          <div class="flex gap-4">
            <!-- Start: Nickname -->
            <div class="basis-1/2">
              <div class="control-group">
                <label for="nickname">Nickname @if (isRequired('nickname')) { <sup>*</sup> }</label>
                <input type="text" id="nickname" class="w-100" formControlName="nickname">
              </div>
            </div>
            <!-- End: Nickname -->

            <!-- Start: Opportunity Number -->
            <div class="basis-1/2">
              <div class="control-group">
                <label class="required" for="opportunity-number">Opportunity Number @if (isRequired('opportunityNumber')) { <sup>*</sup> }</label>
                <input type="text" id="opportunity-number" class="w-100" formControlName="opportunityNumber">
              </div>
            </div>
            <!-- End: Opportunity Number -->
          </div>

          <div class="flex gap-4">
            <!-- Start: Trial Name -->
            <div class="basis-1/2">
              <div class="control-group">
                <label for="trial-name">Trial Name @if (isRequired('name')) { <sup>*</sup> }</label>
                <input type="text" id="trial-name" class="w-100" formControlName="name">
              </div>
            </div>
            <!-- End: Trial Name -->

            <!-- Start: Number of Visits -->
            <div class="basis-1/2">
              <div class="control-group">
                <label for="visit-count">Number of Visits</label>
                <app-dropdown-input #visitCountElement id="visit-count" [options]="visitCountOptions"
                                    [parentForm]="defaultForm" name="visitCount"
                                    [selectedValue]="defaultForm.get('visitCount').value"></app-dropdown-input>
              </div>
            </div>
            <!-- End: Number of Visits -->
          </div>

        </app-panel>
      </div>

      <div class="basis-1/3">
        <app-panel class="h-full" classNames="h-full">
          <h3>Location &amp; Budget</h3>

          <div>
            <!-- Start: Countries -->
            <div class="control-group">
              <label>Countries</label>
              <mat-select formControlName="countries" multiple placeholder="Select Countries...">
                <mat-option *ngFor="let country of countries" [value]="country.code">
                  {{
                    country.name
                  }}
                </mat-option>
              </mat-select>

              <ul class="country-tags mt-1 px-2">
                <li *ngFor="let country of selectedCountries">
                  {{ country.name }} <a (click)="removeCountryFromTrial(country.code)">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </a>
                </li>
              </ul>
            </div>
            <!-- End: Countries -->
          </div>

          <div>
            <!-- Start: Budget Currency -->
            <div class="control-group">
              <label class="required">Budget Currency @if (isRequired('baseCurrency')) { <sup>*</sup> }</label>
              <div>
                <app-autosuggest-dropdown-input #baseCurrencySelect [parentForm]="defaultForm"
                                                [options]="currencyOptions" controlName="baseCurrency" placeholder="Select Base Currency..."
                                                (selectValueChanged)="onBaseCurrencySelected($event)">
                </app-autosuggest-dropdown-input>
              </div>
            </div>
            <!-- End: Budget Currency -->
          </div>

          <!-- Start: Expense Policy Reminders -->
          <div>
            <div class="control-group">
              <label for="description">Expense Policy Reminders @if (isRequired('expensePolicyReminders')) { <sup>*</sup> }</label>
              <textarea class="w-100" id="expensePolicyReminders" formControlName="expensePolicyReminders"
                        placeholder="Add a brief reminder of the trial's expense policy"></textarea>
            </div>
          </div>
          <!-- End: Expense Policy Reminders -->
        </app-panel>
      </div>
    </div>

    <!-- Start: Trial Description -->
    <div class="mb-3">
      <app-panel class="h-full" classNames="h-full">
        <h3>Trial Description</h3>

        <div class="flex flex-col lg:flex-row gap-4">
          <!-- Start: Therapeutic Area -->
          <div class="basis-1/4">
            <div class="control-group">
              <label>Therapeutic Area</label>
              <app-dropdown-input [options]="therapeuticAreaOptions" placeholder="Select..."
                                  [parentForm]="defaultForm" (selectValueChanged)="onTherapeuticAreaChanged($event)"
                                  #therapeuticAreaSelect controlName="therapeuticArea"></app-dropdown-input>
            </div>
          </div>
          <!-- End: Therapeutic Area -->
        </div>

        <div class="flex flex-col lg:flex-row gap-4">
          <!-- Start: Protocol Title -->
          <div class="lg:basis-1/2">
            <div class="control-group">
              <label for="description">Protocol Title @if (isRequired('description')) { <sup>*</sup> }</label>
              <textarea class="w-100" id="description" formControlName="description"
                        placeholder="Add a brief overview or description of the trial ..."></textarea>
            </div>
          </div>
          <!-- End: Protocol Title -->

          <!-- Start: Indications -->
          <div class="lg:basis-1/2">
            <div class="control-group">
              <label for="indications">Indications @if (isRequired('indications')) { <sup>*</sup> }</label>
              <textarea class="w-100" id="indications" formControlName="indications"></textarea>
            </div>
          </div>
          <!-- End: Indications -->
        </div>
      </app-panel>
    </div>
    <!-- End: Trial Description -->

    <!-- Start: Contact & Legal Information -->
    <div class="mb-3">
      <app-panel class="h-full" classNames="h-full">
        <h3>Contact &amp; Legal Information</h3>

        <div class="flex flex-col lg:flex-row gap-4 mb-6">
          <!-- Start: Study Mailbox -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label class="required" for="study-mailbox">Study Mailbox @if (isRequired('studyMailbox')) { <sup>*</sup> }</label>
              <input type="email" id="study-mailbox" class="w-100" formControlName="studyMailbox">
            </div>
          </div>
          <!-- End: Study Mailbox -->

          <!-- Start: Sharepoint Link -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label for="sharepointLink">Trial Sharepoint Link</label>
              <input type="url" id="sharepointLink" class="w-100" formControlName="sharepointLink">
            </div>
          </div>
          <!-- End: Sharepoint Link -->

          <!-- Start: Trial Terms  -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label class="required" for="trial-name">Trial Terms & Conditions URL @if (isRequired('termsUrl')) { <sup>*</sup> }</label>
              <input type="text" id="terms-url" class="w-100" formControlName="termsUrl">
            </div>
          </div>
          <!-- End: Trial Terms -->

          <!-- Start: Trial Privacy Policy -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label class="required" for="trial-name">Trial Privacy Policy URL @if (isRequired('privacyPolicyUrl')) { <sup>*</sup> }</label>
              <input type="url" id="privacy-policy-url" class="w-100" formControlName="privacyPolicyUrl">
            </div>
          </div>
          <!-- End: Trial Privacy Policy -->
        </div>

        <div class="flex flex-col lg:flex-row gap-4 mb-6">
          <!-- Start: PM Name -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label for="pm-name">PM Name</label>
              <input type="text" id="pm-name" class="w-100" formControlName="pmName">
            </div>
          </div>
          <!-- End: PM Name -->

          <!-- Start: PM Email -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label for="pm-email">PM Email</label>
              <input type="email" id="pm-email" class="w-100" formControlName="pmEmail">
            </div>
          </div>
          <!-- End: PM Email -->

          <!-- Start: Coordinator Name -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label for="coordinator-name">Coordinator Name</label>
              <input type="text" id="coordinator-name" class="w-100" formControlName="coordinatorName">
            </div>
          </div>
          <!-- End: Coordinator Name -->

          <!-- Start: Coordinator Email -->
          <div class="lg:basis-1/4">
            <div class="control-group">
              <label for="coordinator-email">Coordinator Email</label>
              <input type="email" id="coordinator-email" class="w-100" formControlName="coordinatorEmail">
            </div>
          </div>
          <!-- End: Coordinator Email -->
        </div>
      </app-panel>
    </div>
    <!-- End: Contact & Legal Information -->

    <!-- Start: Integrations & Features -->
    <div class="mb-3">
      <app-panel class="h-full" classNames="h-full">
        <h3>Integrations &amp; Features</h3>

        <div class="flex flex-col lg:flex-row gap-4 mb-6">
          <!-- Start: Patient Services -->
          <div class="lg:basis-1/3">
            <!-- Start: Test Data Only -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="testDataOnly" formControlName="testDataOnly" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="testDataOnly">Test Data Only</label>
            </div>
            <!-- End: Test Data Only -->

            <!-- Start: Enable Dashboard -->
            <div class="control-group">
              <label class="checkbox" [class.disabled]="defaultForm.get('dashboardEnabled').disabled">
                <input type="checkbox" id="dashboardEnabled" formControlName="dashboardEnabled"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="dashboardEnabled">Enable Dashboard</label>
            </div>
            <!-- End: Enable Dashboard -->

            <!-- Start: Enable Ride Health -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="rideHealthEnabled" formControlName="rideHealthEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="rideHealthEnabled">Enable Ride Health</label>
            </div>
            <!-- End: Enable Ride Health -->

            <!-- Start: Enable MUV -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="muvEnabled" formControlName="muvEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="muvEnabled">Enable MUV</label>
            </div>
            <!-- End: Enable MUV -->

            <!-- Start: Enable Activity Center -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="allowActivityCentre" formControlName="allowActivityCentre"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="allowActivityCentre">Enable Activity Centre</label>
            </div>
            <!-- End: Enable Activity Center -->

            <!-- Start: Booking Enabled -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="bookingEnabled" formControlName="bookingEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="bookingEnabled">Booking Enabled</label>
            </div>
            <!-- End: Booking Enabled -->

            <!-- Start: Travel Additional Info Enabled -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="travelAdditionalInfoEnabled" formControlName="travelAdditionalInfoEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="travelAdditionalInfoEnabled">Travel Additional Info Enabled</label>
            </div>
            <!-- End: Travel Additional Info Enabled -->

            <!-- Start: Video Calling Enabled -->
            @if (featureService.isEnabled('VirtualCalls')) {
              <div class="control-group">
                <label class="checkbox">
                  <input type="checkbox" id="virtualCallsEnabled" formControlName="virtualCallsEnabled" value="true">
                  <span></span>
                </label>
                <label class="checkbox-label" for="virtualCallsEnabled">Virtual Calls Enabled</label>
              </div>

              <div class="control-group">
                <label class="checkbox">
                  <input type="checkbox" id="recordingAskForConsent" formControlName="recordingAskForConsent" value="true">
                  <span></span>
                </label>
                <label class="checkbox-label" for="recordingAskForConsent">Ask for Recording Consent</label>
              </div>
            }
            <!-- End: Video Calling Enabled -->
          </div>
          <!-- End: Patient Services -->

          <!-- Start: Communication -->
          <div class="lg:basis-1/3">
            <!-- Start: Enable Smart Notifications -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="enableSmartNotifications" formControlName="enableSmartNotifications"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="enableSmartNotifications">Enable Smart Notifications</label>
            </div>
            <!-- End: Enable Smart Notifications -->

            <!-- Start: Allow Feedback Requests -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="allowFeedbackRequests" formControlName="allowFeedbackRequests"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="allowFeedbackRequests">Allow Feedback Requests</label>
            </div>
            <!-- End: Allow Feedback Requests -->

            <!-- Start: FAQs -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="faqsEnabled" formControlName="faqsEnabled"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="faqsEnabled">Enable FAQs</label>
            </div>
            <!-- End: FAQs -->

            <!-- Start: Enable E-Diary -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="genericDiaryEnabled" formControlName="genericDiaryEnabled"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="genericDiaryEnabled">Enable E-Diary</label>
            </div>
            <!-- End: Enable E-Diary -->

            <!-- Start: Enable Maze E-Diary -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="diaryEnabled" formControlName="diaryEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="diaryEnabled">Enable Maze E-Diary</label>
            </div>
            <!-- End: Enable Maze E-Diary -->

            <!-- Start: Self Serve Notifications -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="selfServeNotificationsEnabled" formControlName="selfServeNotificationsEnabled">
                <span></span>
              </label>
              <label class="checkbox-label" for="selfServeNotificationsEnabled">
                Enable Self Serve Notifications
              </label>
            </div>
            <!-- End: Self Serve Notifications -->
          </div>
          <!-- End: Communication -->

          <!-- Start: Financial & Booking -->
          <div class="lg:basis-1/">
            <!-- Start: Bank Account in App V2 -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="bankAccountSelfManagementEnabled"
                       formControlName="bankAccountSelfManagementEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="bankAccountSelfManagementEnabled">Bank Account in App
                v2</label>
            </div>
            <!-- End: Bank Account in App V2 -->

            <!-- Start: Card Management in App V2 -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="bankAccountSelfCardManagementEnabled"
                       formControlName="bankAccountSelfCardManagementEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="bankAccountSelfCardManagementEnabled">Card Management in App
                v2</label>
            </div>
            <!-- End: Card Management in App V2 -->

            <!-- Start: Receipt Lead Expense -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="receiptLeadExpenseEnabled"
                       formControlName="receiptLeadExpenseEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="receiptLeadExpenseEnabled">Receipt Lead Expense</label>
            </div>
            <!-- End: Receipt Lead Expense -->

            <!-- Start: Daily Spend Expenses -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="dailySpendExpensesEnabled"
                       formControlName="dailySpendExpensesEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="dailySpendExpensesEnabled">Enable Daily Spend Expenses</label>
            </div>
            <!-- End: Daily Spend Expenses -->

            <!-- Start: Daily Spend Expense App -->
            @if (featureService.isEnabled('DailySpendExpenseApps')) {
              <div class="control-group">
                <label class="checkbox">
                  <input type="checkbox" id="dailySpendExpenseAppEnabled"
                         formControlName="dailySpendExpenseAppEnabled" value="true">
                  <span></span>
                </label>
                <label class="checkbox-label" for="dailySpendExpenseAppEnabled">Enable Daily Spend Expense App</label>
              </div>
            }
            <!-- End: Daily Spend Expense App -->

            <!-- Start: Pfizer Bank Account Details Enabled -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="bankAccountEnabled" formControlName="bankAccountEnabled"
                       value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="bankAccountEnabled">Pfizer - 7051591 Bank Acccount Details
                Enabled</label>
            </div>
            <!-- End: Pfizer Bank Account Details Enabled -->

            <!-- Start: Patient Auto Complete -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="patientAutoCompletion" formControlName="patientAutoCompletion">
                <span></span>
              </label>
              <label class="checkbox-label" for="patientAutoCompletion">
                Patient Auto Completion
                <span class="checkbox-note">
                          *Note: There is no visit schedule yet for new trials so Auto
                          Completion won't apply.
                        </span>
              </label>
            </div>
            <!-- End: Patient Auto Complete -->

            <!-- Start: Virtual card in app -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="virtualCardInAppEnabled"
                       formControlName="virtualCardInAppEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="virtualCardInAppEnabled">Virtual card in app</label>
            </div>
            <!-- End: Virtual card in app -->

            <!-- Start: Nmible bank in app -->
            <div class="control-group">
              <label class="checkbox">
                <input type="checkbox" id="nmibleBankInAppEnabled"
                       formControlName="nmibleBankInAppEnabled" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="nmibleBankInAppEnabled">Nmible bank in app</label>
            </div>
            <!-- End: Nmible bank in app -->

            <!-- Start: Email Patient Visit Created -->
            <div class="control-group" *ngIf="defaultForm.get('apiEnabled').value">
              <label class="checkbox">
                <input type="checkbox" id="emailPatientOnVisitCreation" formControlName="emailPatientOnVisitCreation" value="true">
                <span></span>
              </label>
              <label class="checkbox-label" for="emailPatientOnVisitCreation">Email Patient on Visit Creation</label>
            </div>
            <!-- End: Email Patient Visit Created -->

            <div class="control-group" style="margin-left: 30px" *ngIf="defaultForm.get('emailPatientOnVisitCreation').value && defaultForm.get('apiEnabled').value">
              <label class="required">Patient Email Template</label>
              <mat-select formControlName="requestTravelEmailTemplate" placeholder="Select Template...">
                <mat-option *ngFor="let template of emailTemplateOptions" [value]="template.id">{{ template.value }}</mat-option>
              </mat-select>
            </div>

            <div class="control-group" style="margin-left: 30px" *ngIf="defaultForm.get('emailPatientOnVisitCreation').value && defaultForm.get('apiEnabled').value">
              <label class="required" for="magicLinkExpiryDays">Magic Link Expiry (days)</label>
              <input type="number" id="magicLinkExpiryDays" class="w-100" formControlName="magicLinkExpiryDays">
            </div>
          </div>
          <!-- End: Financial & Booking -->
        </div>

        <!-- Start: API Integration -->
        <div class="control-group">
          <label class="checkbox">
            <input type="checkbox" id="apiEnabled" formControlName="apiEnabled" value="true">
            <span></span>
          </label>
          <label class="checkbox-label" for="apiEnabled">Enable API integration</label>

          <div class="form-group" style="margin-left: 30px" *ngIf="defaultForm.get('apiEnabled').value">
            <label for="apiConsumerIds">API Consumers</label>
            <app-input-multi-select [parentForm]="defaultForm" controlName="apiConsumerIds" [items]="apiConsumerOptions" inputPlaceholder="Select consumers..."></app-input-multi-select>
            <p class="checkbox-note">A trial uses either one or more first-party consumers, or a single third-party consumer &mdash; never a mixture. Choose carefully: while the trial is still empty its consumers can be changed freely, but once it has patients or sites it cannot be moved between first-party and third-party, and a third-party trial's consumer is fixed &mdash; its patients are registered against that consumer and would become invisible to both parties. An API-enabled trial must keep at least one consumer.</p>
          </div>
        </div>
        <!-- End: API Integration -->
      </app-panel>
    </div>
    <!-- End: Integrations & Features -->

    <div class="flex justify-end gap-4 pr-4 mb-6">
      <app-button href="/trial/" text="Cancel" variant="secondary"
                  width="fill"></app-button>
      <app-button (clicked)="onFormSubmit()" text="Save" [isBusy]="defaultForm.get('isBusy').value"
                  width="fill"
                  [disabled]="defaultForm.invalid || defaultForm.get('isBusy').value"></app-button>
    </div>

  </form>

</div>
